import { useTranslation } from 'react-i18next';

export const keyPrefix = 'duplicate_role';
export const useDuplicateRoleTranslation = () => useTranslation('features', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    toast_success: 'Дубликат роли успешно создан',
    toast_error: 'Не удалось создать дубликат роли',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    toast_success: 'Role duplicate created successfully',
    toast_error: 'Failed to create role duplicate',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    toast_success: 'Duplicado de rol creado con éxito',
    toast_error: 'Error al crear el duplicado de rol',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    toast_success: 'Duplicado de função criado com sucesso',
    toast_error: 'Falha ao criar o duplicado de função',
  },
}) as Record<string, unknown>;
